import { UserOrder } from "../../../../interfaces";
import { toast } from "react-toastify";
import TextAreaFieldInlineEdit from "../../../common/TextAreaFieldInlineEdit";
import useOrder from "../../../../hooks/useOrder";
import { API, graphqlOperation } from "aws-amplify";
// @ts-expect-error type exists
import { createActivityLog } from "../../../../graphql/mutations";
import { useUser } from "../../../../contexts";

const ManufacturerNote = ({
  order,
  onUpdateManufacturerNote = () => {},
}: {
  order: UserOrder;
  onUpdateManufacturerNote?: (value: UserOrder) => void;
}) => {
  const { handleOrderUpdate } = useOrder();
  const [{ user }] = useUser();
  /**
   * This method is for update internal note in backend order api
   * @param { string } manufacturerNote updated internal text
   */
  const handleCreateActivityLog = async (
    oldNote: string,
    newNote: string,
    orderId?: string,
    lastUpdatedBy?: string
  ) => {
    const logDetails = {
      operation: "CHANGE",
      field: "note",
      value: JSON.stringify([
        `old: ${oldNote}`,
        `new: ${newNote}`,
        `logtype: manufacturer`,
      ]),
      orderItemActivityLogsId: orderId,
      typename: "activityLog",
      updatedBy: lastUpdatedBy,
    };

    try {
      await API.graphql(
        graphqlOperation(createActivityLog, { input: logDetails })
      );
    } catch (error) {
      console.error("Fehler beim Erstellen des Activity Logs:", error);
    }
  };
  const handleUpdateManufacturerNote = async (manufacturerNote: string) => {
    try {
      if (!order) return;
      const responseOrder = await handleOrderUpdate({
        id: order.id,
        manufacturerNote,
      });
      if (!responseOrder) return;
      onUpdateManufacturerNote(responseOrder);
      toast.success("Manufacturer Note Updated.");

      // Hier wird der ActivityLog-Eintrag erstellt

      if (user?.isAdmin || user?.isManufacturer) {
        await handleCreateActivityLog(
          order.manufacturerNote ?? "",
          manufacturerNote,
          order.id,
          order.lastUpdatedBy
        );
      } else {
        await handleCreateActivityLog(
          order.manufacturerNote ?? "",
          manufacturerNote,
          order.id,
          user?.email || order.email || ""
        );
      }
    } catch (error) {
      if (error && (error as Error).message) {
        toast.error((error as Error).message);
      } else {
        toast.error("We are unable to update order please contact admin.");
      }
    }
  };

  return (
    <div className="w-100">
      <div className="m-h-240 box-sizing-bb card-auto p-16 address-details">
        <TextAreaFieldInlineEdit
          label={"manufacturerNote"}
          text={order.manufacturerNote ?? ""}
          isEditable={true}
          onChange={(manufacturerNote) =>
            handleUpdateManufacturerNote(manufacturerNote)
          }
        />
      </div>
    </div>
  );
};

export default ManufacturerNote;
